import "../../../../assets/RideMenuOption.css";
import t, { forwardRef as w, useState as p, useEffect as S, useImperativeHandle as H } from "react";
import O from "clsx";
import { RideGlCheck as R } from "../../graphic/glyph/components/RideGlCheck.js";
import v from "lodash.uniqueid";
const C = "_option_10bqe_89", z = "_input_10bqe_94", D = "_label_10bqe_98", G = "_text_10bqe_101", I = "_graphic_10bqe_142", B = "_loading_10bqe_167", K = "_rotate_10bqe_1", n = {
  "ride-menu-option": "_ride-menu-option_10bqe_54",
  option: C,
  input: z,
  "glyph-checked": "_glyph-checked_10bqe_95",
  label: D,
  text: G,
  graphic: I,
  "message-empty-options": "_message-empty-options_10bqe_150",
  "loading-option": "_loading-option_10bqe_167",
  loading: B,
  "fade-in": "_fade-in_10bqe_1",
  "fade-out": "_fade-out_10bqe_1",
  rotate: K,
  "slide-in-up": "_slide-in-up_10bqe_1",
  "slide-in-down": "_slide-in-down_10bqe_1",
  "fill-center-out": "_fill-center-out_10bqe_1"
}, M = w(
  ({
    id: d,
    className: m,
    loading: a,
    messageEmptyOptions: _,
    name: u,
    onClick: g,
    onChange: b,
    options: i = [],
    showMaxOptions: s,
    "aria-label": h,
    "data-testid": f
  }, q) => {
    const [y, E] = p(0), [r] = p(d ?? v(":ride:"));
    S(() => {
      E(c());
    }, []), H(q, () => ({
      getHeight: c
    }));
    const N = () => O(m, n["ride-menu-option"]), c = () => {
      const e = s ?? i.length;
      return 44 * e + 4 * (e > 2 ? e - 1 : 0) + 14 + 2;
    }, k = () => s ? { maxHeight: `${y}px` } : void 0, x = (e) => {
      if (e.code === "Space" || e.code === "Enter") {
        const l = e.target.querySelector("input");
        if (!l) return;
        l.click();
      }
    };
    return /* @__PURE__ */ t.createElement(
      "ul",
      {
        className: N(),
        style: k(),
        role: a ? "list" : "listbox",
        id: r,
        "aria-label": h,
        "data-testid": f
      },
      a && Array(5).fill("").map((e, o) => /* @__PURE__ */ t.createElement("li", { key: o, className: n["loading-option"] }, e)),
      !a && i.map((e) => /* @__PURE__ */ t.createElement(
        "li",
        {
          role: "option",
          className: n.option,
          key: e.value,
          tabIndex: 0,
          onKeyDown: (o) => x(o)
        },
        /* @__PURE__ */ t.createElement("label", { className: n.label, title: e.label }, /* @__PURE__ */ t.createElement(
          "input",
          {
            checked: e.checked || !1,
            className: n.input,
            type: "radio",
            value: e.value,
            name: u || `name-${r}`,
            onClick: g,
            onChange: b,
            readOnly: !0
          }
        ), e.graphic && /* @__PURE__ */ t.createElement("div", { className: n.graphic }, e.graphic), /* @__PURE__ */ t.createElement("span", { className: n.text }, e.label), /* @__PURE__ */ t.createElement(
          R,
          {
            size: "large",
            fill: "currentColor",
            className: n["glyph-checked"]
          }
        ))
      )),
      !a && !i || i.length === 0 && /* @__PURE__ */ t.createElement("li", { role: "option", className: n.option }, /* @__PURE__ */ t.createElement("span", { className: n["message-empty-options"] }, _))
    );
  }
);
M.displayName = "RideMenuOption";
export {
  M as RideMenuOption
};
